const state = () => ({
    variations:null,
    zubehoer:null,
    added:false

});

const mutations =
    {

        setItemAdded(state, request)
        {
            state.added = request;
        },
        setPhyweVariations(state, request)
        {
            state.variations = request;
        },
        setZubehoer(state, request)
        {
            state.zubehoer = request;
        }
    };

export default
{
    state,
    mutations
};
